<template>
	<div>
	    <div >
				    <van-list
				      v-model="myvideoloading"
				      :finished="myvideofinished"
				      :finished-text="myvideofinishedtext"
				      @load="getCourseList"
				      offset="200"
				      :immediate-check="false"
				      ref="myvideolist"
					  style="margin-bottom: 4rem;"
				    >
				  <div class="courseitem"
				  v-for="(item, index) in myvideolist"
				  :key="index"
				  >
					  <div class="courseimg">
						  <div><img :src="item.coverImage" width="100%"/></div>
					  </div>
					  <div class="coursetitle"><div class="title">{{item.name}}</div>
						<div>授课形式：{{item.typeTags}}</div>
					  </div>
					  <div class="coursebar">
						  <div class="courseplay" @click="mycourseplay(item)" ><van-icon name="play" style="vertical-align: middle;margin-right: 0.3125rem;" size="23" />进入学习</div>
						  <div class="coursefile" @click="myvideodocfile(item)" ><svg-icon icon-class="download" style="vertical-align: middle;margin-right: 0.3125rem; font-size: 23px;"/>课件下载</div>
					  </div>
				  </div>
				</van-list>
				<van-empty description="请先购买课程" v-if="myvideolist.length==0"/>
				<div style="height: 50px;"></div>
			  </div>
	<Tabbar></Tabbar>
	</div>
</template>

<script>
	import { Toast } from 'vant';
	import Tabbar from '@/components/tabbar.vue';
	import {api_user} from '@/common/Request.js';
	export default {
	  data() {
	    return {
	      tactive: 0,
		  usertoken:'',
		  myvideolist:[],
		  mylivelist:[],
		  myvideoloading:false,
		  myliveloading:false,
		  myvideorefrehing:false,
		  myliverefrehing:false,
		  myvideohas_next:true,
		  mylivehas_next:true,
		  myvideopagesize:10,
		  mylivepagesize:10,
		  myvideopagenum:1,
		  mylivepagenum:1,
		  myvideototal:0,
		  mylivetotal:0,
		  myvideofinished:false,
		  mylivefinished:false,
		  myvideofinishedtext:'',
		  mylivefinishedtext:''
		  
	    };
	  },
	  components: {
	  Tabbar
	},
	mounted() {
		console.log(this.$cookies.isKey("user_token"));
		 document.body.style.backgroundColor = '#efefef';
		if(this.$cookies.isKey("user_token"))
		{
			this.usertoken=this.$cookies.get("user_token");
			//this.getmyvideolist();
			//this.getmylivelist();
			this.getCourseList();
		}
	},
	beforeDestroy() {
	    // 组件销毁前，可选择恢复原样式
	    document.body.style.backgroundColor = '';
	},
	methods:{
		getmyvideolist(){
			this.myvideoloading=true;
			if (this.myvideorefrehing) {
			          this.myvideolist = [];
			          this.myvideorefrehing = false;
			}
			if (this.myvideohas_next){
			api_user.my_video(this.myvideopagesize,this.myvideopagenum,this.usertoken).then(response=>{
				console.log(response.data);
				const list = response.data;
				list.forEach(item => {
				  if(item.goods_thumb==''){
					item.goods_thumb_full="http://v.huazhi.cn/images/no_picture.gif";
				  }
				});
				this.myvideolist=[...this.myvideolist,...list];
				this.myvideototal = parseInt(response.msg);
				console.log(this.myvideototal);
				this.myvideoloading=false;
				if(this.myvideototal>0&&this.myvideototal>this.myvideopagesize){
				if ((this.myvideopagenum) * this.myvideopagesize < this.myvideototal) {
				  this.myvideohas_next = true;
				} else {
				  this.myvideohas_next = false;
				}
				this.myvideopagenum++;
				}
				else{
					console.log(this.myvideoloading);
					console.log(this.myvideorefrehing);
					console.log(this.myvideofinished);
					this.myvideoloading=false;
					this.myvideofinished=true;
					this.myvideofinishedtext="";
					this.myvideohas_next=false;
				}
				
			})
			.catch(function(error){
				console.log(error);
			})
			}
			else{
				this.myvideoloading=false;
			}
			
		},
		getmylivelist(){
			
				this.myliveloading=true;
				if (this.myliverefrehing) {
				          this.mylivelist = [];
				          this.myliverefrehing = false;
				}
				if (this.mylivehas_next){
				api_user.my_live(this.mylivepagesize,this.mylivepagenum,this.usertoken).then(response=>{
					console.log(response.data);
					const list = response.data;
					list.forEach(item => {
					  if(item.goods_thumb==''){
						item.goods_thumb_full="http://v.huazhi.cn/images/no_picture.gif";
					  }
					});
					this.mylivelist=[...this.mylivelist,...list];
					this.mylivetotal = parseInt(response.msg);
					console.log(this.mylivetotal);
					this.myliveloading=false;
					if(this.mylivetotal>0&&this.mylivetotal>this.mylivepagesize){
					if ((this.mylivepagenum) * this.mylivepagesize < this.mylivetotal) {
					  this.mylivehas_next = true;
					} else {
					  this.mylivehas_next = false;
					}
					this.mylivepagenum++;
					}
					else{
						console.log(this.myliveloading);
						console.log(this.myliverefrehing);
						console.log(this.mylivefinished);
						this.mylivefinished=true;
						this.mylivefinishedtext="";
						this.mylivehas_next=false;
					}
					
				})
				.catch(function(error){
					console.log(error);
				})
				}
				else{
					this.myliveloading=false;
				}
			
		},
		myvideorefreh(){
			this.myvideorefrehing=true;
			this.myvideofinished = false;
			this.myvideolist=[];
			this.myvideopagenum = 1;
			this.myvideohas_next = true;
			this.getmyvideolist();
		},
		myliverefreh(){
			this.myliverefrehing=true;
			this.mylivefinished = false;
			this.mylivelist=[];
			this.mylivepagenum = 1;
			this.mylivehas_next = true;
			this.getmylivelist();
		},
		mycourseplay(item){
			this.$router.push({
				path:"goods_detail",
				query:{goodsid:item.courseId}
			});
			
			// api_user.getCourseResourceTree(item.courseId).then(res=>{
			// 	let leaflist=this.findfirstLeaf(res.data.root);
			// 	console.log(leaflist);
			// 	if(leaflist.length>0)
			// 	{
			// 		for(var leafindex in leaflist)
			// 		{
			// 			if(leaflist[leafindex].item.resourceType==2)
			// 			{
			// 				this.$router.push({
			// 				  path: "course_detail",
			// 				  query: { courseId:item.courseId,
			// 						   resourceId:leaflist[leafindex].item.resourceId
			// 				  }
			// 				});
			// 				break;
			// 			}
			// 			else if(leaflist[leafindex].item.resourceType==1&&leaflist[leafindex].item.lessonStatus<3)
			// 			{
			// 				this.$router.push({
			// 				  path: "live_detail",
			// 				  query: { courseId:item.courseId,
			// 						   resourceId:leaflist[leafindex].item.resourceId
			// 				  }
			// 				});
			// 				break;
			// 			}
			// 			else if(leaflist[leafindex].item.resourceType==1&&leaflist[leafindex].item.lessonStatus==3)
			// 			{
			// 				this.$router.push({
			// 				  path: "live_replay",
			// 				  query: { courseId:item.courseId ,
			// 						   resourceId:leaflist[leafindex].item.resourceId
			// 				  }
			// 				});
			// 				break;
			// 			}
			// 		}
			// 	}
			// 	else{
			// 		Toast('当前课程暂无播放项目请联系老师解决！');
			// 	}

				
			// })
		},
		findfirstLeaf(treeNodes){
			    var temp = []
			      var forFn = function (node) {
					if(node.isLeaf){
						temp.push(node);
					}
					else{
						for(var treeindex in node.children)
						{
							forFn(node.children[treeindex]);
						}
					}
			      }
			      forFn(treeNodes)
			      return temp;
		},
		myliveplay(item){
			this.$router.push({
			  path: "live_detail",
			  query: { goodsid: item.courseId }
			});
		},
		myvideodocfile(item){
			this.$router.push({
			  path: "docfile_list",
			  query: { goodsid: item.courseId }
			});
		},
		mylivereplay(item){
			this.$router.push({
			  path: "live_replay",
			  query: { goodsid: item.goods_id }
			});
		},
		getCourseList(){
			api_user.getMyCourseList().then(res=>{
				if(res.code==0){
					console.log(res);
					const list = res.data;
					list.forEach(item => {
					  if(item.coverImage==''){
						item.coverImage="http://v.huazhi.cn/images/no_picture.gif";
					  }
					});
					this.myvideolist=[...list];
					this.myvideoloading=false;
					this.myvideofinished=true;
				}
				else if(res.code==-403){
					this.$cookies.remove("user_token");
					this.$cookies.remove("mobile");
					this.$cookies.remove("userId");
					this.$router.push('/auth_new');
				}
				
			})
		}
	}
	};
</script>

<style lang="scss" scoped="">
	.courseitem{
		flex:1 1 100%;
		display: flex;
		flex-direction: row;
		border-radius: 6px;
		// box-shadow: 0 2px 6px rgba(100,100,100,0.5);
		//border: solid 1px #cccccc;
		background-color: white;
		margin: 0.625rem 0.625rem 0 0.625rem;
		flex-wrap: wrap;
		align-items: stretch;
		.courseimg{
			flex:0 0 40%;
			div{
				padding: 0.9375rem 0.9375rem 0.75rem 0.9375rem;
				img{
					border-radius: 0.3125rem;
				}
			}
			
		}
		.coursetitle{
			flex:0 0 60%;
			align-self: stretch;
			.title{
				padding-top: 0.9375rem;
				display:-webkit-box;
				overflow:hidden;
				text-overflow:ellipsis;
				-webkit-line-clamp:2;
				-webkit-box-orient:vertical;
				padding-right: 0.9375rem;
				color:#333;
				font-size: 14px;
				padding-bottom: 0.625rem;
			}
		}
		.coursebar{
			flex:1 0 100%;
			height: 2.5rem;
			display: flex;
			flex-direction: row;
			border-top: solid 1px #cccccc;
			.courseplay{
				flex:0 0 50%;
				text-align: center;
				line-height: 2.5rem;
				color:#999;
			}
			.coursefile{
				flex:0 0 50%;
				border-left:solid 1px #cccccc;
				text-align: center;
				line-height: 2.5rem;
				color:#999;
			}
		}
		
	}
	.liveitem{
		display: flex;
		flex-direction: row;
		border-radius: 0.3125rem;
		box-shadow: 0 2px 6px rgba(100,100,100,0.5);
		margin: 0.625rem 0.625rem 0 0.625rem;
		flex-wrap: wrap;
		.liveimg{
			flex:0 0 40%;
			div{
				padding: 0.625rem;
				img{
					border-radius: 0.3125rem;
				}
			}
			
		}
		.livetitle{
			flex:0 0 60%;
			align-self: stretch;
			div{
				padding-top: 0.625rem;
				padding-bottom: 0.625rem;
				padding-right: 0.625rem;
				overflow: hidden;
				color:#696969;
			}
		}
		.livebar{
			flex:1 0 100%;
			height: 2.5rem;
			display: flex;
			flex-direction: row;
			.liveplay{
				flex:0 0 50%;
				text-align: center;
				line-height: 2.5rem;
				color:#999;
			}
			.livereplay{
				flex:0 0 50%;
				border-left:solid 1px rgba(100,100,100,0.5);
				text-align: center;
				line-height: 2.5rem;
				color:#999;
			}
		}
		
	}
</style>
